import * as XLSX from 'xlsx'

export type DetectedFormat = 'pull-planning' | 'gantt' | 'unknown'

export const detectFormat = (buf: ArrayBuffer): DetectedFormat => {

  let wb: XLSX.WorkBook
  try {
    wb = XLSX.read(buf, { type: 'array' })
  } catch {
    return 'unknown'
  }

  const sheetName = wb.SheetNames[0]
  if (!sheetName) return 'unknown'

  const sheet = wb.Sheets[sheetName]
  if (!sheet) return 'unknown'

  const headerRow = (XLSX.utils.sheet_to_json(sheet, {
    header: 1,
    range: 0,
    blankrows: false,
  }) as any[])[0] || []

  const normalizedHeaders = (headerRow as any[])
    .map((h: any) => (h == null ? '' : String(h).trim().toLowerCase()))
    .filter(Boolean)

  if (normalizedHeaders.includes('nombre')) return 'gantt'

  if (normalizedHeaders.length === 4) return 'pull-planning'

  return 'unknown'
}
